
<template>
    <div class="Background">
        <h2 class="Title">VOD 통계</h2>
        <VodStatistics />
    </div>
</template>

<script>
import  VodStatistics from '@/components/statistics/vodstatistics/VodStatistics.vue';

export default {
    components: {
        VodStatistics,
    },
    data() {
        return {
            
        };
    }
}
</script>

<style lang="scss" scoped>

</style>
